import { createRouter, createWebHistory } from "vue-router";
import HomeView from "@/views/home/HomeView.vue";
import { menuConfig } from "@/views/dashboard/menuConfig";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      name: "home",
      component: HomeView,
    },
    {
      path: "/premium",
      name: "premium",
      component: () => import("@/views/premium/PremiumView.vue"),
    },
    {
      path: "/privacy-policy",
      name: "PrivacyPolicy",
      beforeEnter() {
        window.location.href = "/privacy-policy.html";
      },
    },
    {
      path: "/c/:code",
      name: "collection",
      component: () => import("@/views/collection/CollectionView.vue"),
      props: true,
      beforeEnter: (to, from, next) => {
        const code = to.params.code;
        // 验证code是否为有效的36进制数（最多6位）
        const isValid = /^[0-9a-z]{1,6}$/i.test(code);
        if (!isValid) {
          next('/');
          return;
        }
        next();
      },
    },
    {
      path: "/:primaryMenu/:secondaryMenu",
      component: () => import("@/views/dashboard/DashBoard.vue"),
      props: true,
      beforeEnter: (to, from, next) => {
        const { primaryMenu, secondaryMenu } = to.params;

        // 检查一级菜单是否存在
        const primaryMenuExists = menuConfig[primaryMenu];
        if (!primaryMenuExists) {
          next("/"); // 或者跳转到 404
          return;
        }

        // 检查二级菜单是否存在
        const secondaryMenuExists = primaryMenuExists.items.some(
          (item) => item.key === secondaryMenu
        );

        if (!secondaryMenuExists) {
          next("/"); // 或者跳转到 404
          return;
        }

        next();
      },
    },
    {
      path: "/:relativeUrl",
      name: "fileView",
      component: () => import("@/views/easyfile/EasyFileView.vue"),
      props: true,
    },
  ],
});

const DEFAULT_TITLE = "简单云链 EasyLink | 免费文件转链接工具 二维码生成器";
const DEFAULT_DESCRIPTION = "让每个人都拥有自己的数字资产——万物皆可转为短链、二维码，轻松分享、售卖、消费。";
const DEFAULT_CANONICAL_URL = "https://easylink.cc/";

function updateMetaTagInRouter(name, content) {
  console.log(`[Router] updateMetaTagInRouter called for name: ${name}, content: ${content}`);
  document.querySelectorAll(`meta[name="${name}"]`).forEach(tag => {
    console.log(`[Router] Removing existing meta[name="${name}"] with content: ${tag.content}`);
    tag.remove();
  });
  const newTag = document.createElement('meta');
  newTag.setAttribute('name', name);
  newTag.setAttribute('content', content);
  document.head.appendChild(newTag);
  console.log(`[Router] Added meta[name="${name}"] with content: ${content}`);
}

function updateLinkTagInRouter(rel, href) {
  console.log(`[Router] updateLinkTagInRouter called for rel: ${rel}, href: ${href}`);
  document.querySelectorAll(`link[rel="${rel}"]`).forEach(tag => {
    console.log(`[Router] Removing existing link[rel="${rel}"] with href: ${tag.href}`);
    tag.remove();
  });
  const newTag = document.createElement('link');
  newTag.setAttribute('rel', rel);
  newTag.setAttribute('href', href);
  document.head.appendChild(newTag);
  console.log(`[Router] Added link[rel="${rel}"] with href: ${href}`);
}

router.afterEach((to, from) => {
  console.log(`[Router] afterEach: Navigating from ${from.name || 'unknown'} to ${to.name || 'unknown'}`);
  if (to.name !== 'fileView') {
    console.log(`[Router] Current route is NOT fileView (${to.name}). Resetting to defaults.`);
    document.title = DEFAULT_TITLE;
    console.log(`[Router] Set document.title to: ${DEFAULT_TITLE}`);
    updateMetaTagInRouter("description", DEFAULT_DESCRIPTION);
    updateLinkTagInRouter("canonical", DEFAULT_CANONICAL_URL);
  } else {
    console.log(`[Router] Current route IS fileView (${to.name}). Will be handled by component.`);
  }
});

export default router;
